import PropertyListComponent from "../../propertyNew/PropertyListComponent";

const PropertyCustomer = () => {
  return (
    <PropertyListComponent
      route="/customer/properties"
      apiPath="/all/property/latestList"
      method="GET"
      requiresAuth={false}
    />
  );
};

export default PropertyCustomer;
